// Enum for logical unit types avec labels multilingues

export interface LogicalUnitTypeLabel {
  fr: string;
  en: string;
}

export interface LogicalUnitType {
  value: string;
  label: LogicalUnitTypeLabel;
}

export const LOGICAL_UNIT_TYPES: LogicalUnitType[] = [
  {
    value: "admin",
    label: {
      fr: "Administratif",
      en: "Administrative",
    },
  },
  {
    value: "organizational",
    label: {
      fr: "Organisation",
      en: "Organizational",
    },
  },
];
